export class StatusMessages {
  public static InsufficientData(requestDate: string, errorMessage: string): string {
    return `Credit check attempted on ${requestDate}. Insufficient data to complete credit check
      - please ensure all necessary data is complete and try again: ${errorMessage}`
  }

  public static Error(errorMessage: string): string {
    return `There was an error while performing credit check:
      ${errorMessage}`
  }

  public static Generic(requestDate: string, status: string): string {
    return `Credit check requested on ${requestDate}. Credit check: ${status}`;
  }

}
